<div class="header-bar">
  <h1>Customer Orders Report Beta</h1>
</div>
<div class="content-container">
  <div class="">
    <form (ngSubmit)="search()" style="width: 100%">
      <div class="ui-g filterPanel form-group">
        <div class="ui-g-12 ui-md-4 ui-lg-2">
          <span class="md-inputfield filterItem">
            <p-calendar
              [(ngModel)]="filterVal.filters.createdDateFrom.value"
              name="createDateFrom"
              dateFormat="dd/mm/yy"
            ></p-calendar>
            <label>Created Date From</label>
          </span>
        </div>

        <div class="ui-g-12 ui-md-4 ui-lg-2">
          <span class="md-inputfield filterItem">
            <p-calendar
              [(ngModel)]="filterVal.filters.createdDateTo.value"
              name="createDateTo"
              dateFormat="dd/mm/yy"
            ></p-calendar>
            <label>Created Date To</label>
          </span>
        </div>

        <div class="ui-g-12 ui-md-4 ui-lg-2">
          <span class="md-inputfield filterItem">
            <p-calendar
              [(ngModel)]="filterVal.filters.completedDateFrom.value"
              name="completedDateFrom"
              dateFormat="dd/mm/yy"
            ></p-calendar>
            <label>Completed Date From</label>
          </span>
        </div>

        <div class="ui-g-12 ui-md-4 ui-lg-2">
          <span class="md-inputfield filterItem">
            <p-calendar
              [(ngModel)]="filterVal.filters.completedDateTo.value"
              name="completedDateTo"
              dateFormat="dd/mm/yy"
            ></p-calendar>
            <label>Completed Date To</label>
          </span>
        </div>

        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <div class="ui-g-3">
            <label>Movement Type</label>
          </div>
          <div class="ui-g-9">
            <p-dropdown
              [options]="taskTypes"
              autoWidth="false"
              [style]="{ width: '100%' }"
              [(ngModel)]="filterVal.filters.type.value"
              name="type"
            ></p-dropdown>
          </div>
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <div class="ui-g-3">
            <label>Department</label>
          </div>
          <div class="ui-g-9">
            <p-dropdown
              [options]="departments"
              autoWidth="false"
              [style]="{ width: '100%' }"
              [(ngModel)]="filterVal.filters.department.value"
              (onChange)="departmentChange($event)"
              name="department"
            ></p-dropdown>
          </div>
        </div>

        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <div class="ui-g-3">
            <label>Team</label>
          </div>
          <div class="ui-g-9">
            <p-dropdown
              [options]="teams"
              autoWidth="false"
              [style]="{ width: '100%' }"
              [(ngModel)]="filterVal.filters.team.value"
              name="team"
            ></p-dropdown>
          </div>
        </div>

        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <div class="ui-g-3">
            <label>Status</label>
          </div>
          <div class="ui-g-9">
            <p-multiSelect
              [options]="orderStatuses"
              autoWidth="false"
              [style]="{ width: '100%' }"
              [(ngModel)]="filterVal.filters.status.value"
              name="status"
            ></p-multiSelect>
          </div>
        </div>

        <div class="ui-g-12">
          <button
            pButton
            type="button"
            label="Clear"
            class="ui-button btn-to-right"
            (click)="clearFilter(dt)"
          ></button>
          <button pButton type="submit" label="Search" class="ui-button btn-to-right"></button>
        </div>
      </div>
    </form>

    <div class="overflow-x-scroll">
      <p-table
        #dt
        selectionMode="single"
        [resizableColumns]="true"
        [value]="page.items"
        [lazy]="true"
        [rows]="10"
        [paginator]="true"
        rowHover="true"
        [totalRecords]="page.total"
        (onLazyLoad)="onGridLazyLoad($event)"
        [loading]="isLoading"
        [rowsPerPageOptions]="[5, 10, 20]"
        [pageLinks]="3"
        (onSort)="changeSort($event)"
      >
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 130px" pResizableColumn pSortableColumn="orderNumber">
              Order Number
            </th>
            <th style="width: 180px" pResizableColumn pSortableColumn="customerOrderNumber">
              Internal Customer Order No
            </th>
            <th style="width: 200px" pResizableColumn pSortableColumn="orderCreationDate">
              Order Creation Date
            </th>
            <th style="width: 150px" pResizableColumn pSortableColumn="movementCompletedDate">
              Movement Completed Date
            </th>
            <th style="width: 150px" pResizableColumn pSortableColumn="scheduledDate">
              Scheduled Date
            </th>
            <th style="width: 150px" pResizableColumn pSortableColumn="vehicleRegistration">
              Vehicle Registration
            </th>
            <th style="width: 150px" pResizableColumn pSortableColumn="vehicleDescription">
              Vehicle Description
            </th>
            <th style="width: 150px" pResizableColumn pSortableColumn="vehicleWeight">
              Vehicle Weight
            </th>
            <th style="width: 150px" pResizableColumn pSortableColumn="collectionAddress">
              Collection Address
            </th>
            <th style="width: 150px" pResizableColumn pSortableColumn="collectionPostcode">
              Collection Postcode
            </th>
            <th style="width: 150px" pResizableColumn pSortableColumn="deliveryAddress">
              Delivery Address
            </th>
            <th style="width: 150px" pResizableColumn pSortableColumn="deliveryPostcode">
              Delivery Postcode
            </th>
            <th style="width: 140px" pResizableColumn pSortableColumn="earliestPickupDate">
              Earliest Pickup
            </th>
            <th style="width: 140px" pResizableColumn pSortableColumn="latestPickupDate">
              Latest Pickup
            </th>
            <th style="width: 200px" pResizableColumn pSortableColumn="movementStatus">
              Movement Status
            </th>
            <th style="width: 130px" pResizableColumn pSortableColumn="odometerStart">
              Odometer Start
            </th>
            <th style="width: 130px" pResizableColumn pSortableColumn="odometerEnd">
              Odometer End
            </th>
            <th style="width: 130px" pResizableColumn pSortableColumn="googleMiles">Google End</th>
            <th style="width: 130px" pResizableColumn pSortableColumn="movementType">
              Movement Type
            </th>
            <th style="width: 140px" pResizableColumn pSortableColumn="movementCharge">
              Movement Charge
            </th>
            <th style="width: 140px" pResizableColumn pSortableColumn="transactionFee">
              Transaction Fee
            </th>
            <th style="width: 130px" pResizableColumn pSortableColumn="bookedByUser">
              Booked By User
            </th>
            <th style="width: 130px" pResizableColumn pSortableColumn="orderTag">Order Tag</th>
            <th style="width: 130px" pResizableColumn pSortableColumn="department">Department</th>
            <th style="width: 130px" pResizableColumn pSortableColumn="team">Team</th>
            <th style="width: 130px" pResizableColumn pSortableColumn="taskArrivedStep">
              Task Arrived Step
            </th>
            <th style="width: 130px" pResizableColumn pSortableColumn="taskStartMovement">
              Task Start Movement
            </th>
            <th style="width: 130px" pResizableColumn pSortableColumn="taskTravelTime">
              Task Travel Time
            </th>
            <th style="width: 130px" pResizableColumn pSortableColumn="totalAdditionalCharge">
              Additional Charge
            </th>
            <th style="width: 130px" pResizableColumn pSortableColumn="totalCharge">
              Total Charge
            </th>
            <th style="width: 130px" pResizableColumn>PO Number</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
          <tr [pSelectableRow]="item" class="no-wrap-cells cells-overflow-hidden">
            <td>{{ item.orderNumber }}</td>
            <td>{{ item.customerOrderNumber }}</td>
            <td>
              <span>{{ item.orderCreationDate | datex : "ddd DD MMM 'YY HH:mm" }}</span>
            </td>
            <td>
              <span>{{ item.movementCompletedDate | datex : "ddd DD MMM 'YY HH:mm" }}</span>
            </td>
            <td>
              <span>{{ item.scheduledDate | datex : "ddd DD MMM 'YY HH:mm" }}</span>
            </td>
            <td>{{ item.vehicleRegistration }}</td>
            <td>{{ item.vehicleDescription }}</td>
            <td>{{ item.vehicleWeight }}</td>
            <td>{{ item.collectionAddress }}</td>
            <td>{{ item.collectionPostcode }}</td>
            <td>{{ item.deliveryAddress }}</td>
            <td>{{ item.deliveryPostcode }}</td>
            <td>{{ item.earliestPickupDate | datex : "ddd DD MMM 'YY HH:mm" }}</td>
            <td>{{ item.latestPickupDate | datex : "ddd DD MMM 'YY HH:mm" }}</td>
            <td>{{ item.movementStatus }}</td>
            <td>{{ item.odometerStart }}</td>
            <td>{{ item.odometerEnd }}</td>
            <td>{{ item.googleMiles }}</td>
            <td>{{ item.movementType }}</td>
            <td>
              <span>
                {{ item.movementCharge | currency : 'GBP' : 'symbol' : '1.2-2' }}
              </span>
            </td>
            <td>
              <span>
                {{ item.transactionFee | currency : 'GBP' : 'symbol' : '1.2-2' }}
              </span>
            </td>
            <td>{{ item.bookedByUser }}</td>
            <td>{{ item.orderTag }}</td>
            <td>{{ item.department }}</td>
            <td>{{ item.team }}</td>
            <td>
              <span>{{ item.taskArrivedStep | datex : "ddd DD MMM 'YY HH:mm" }}</span>
            </td>
            <td>
              <span>{{ item.taskStartMovement | datex : "ddd DD MMM 'YY HH:mm" }}</span>
            </td>

            <td>
              <span>
                {{ item.taskTravelTime }}
              </span>
            </td>
            <td>
              <span>
                {{ item.totalAdditionalCharge | currency : 'GBP' : 'symbol' : '1.2-2' }}
              </span>
            </td>
            <td>{{ item.totalCharge | currency : 'GBP' : 'symbol' : '1.2-2' }}</td>
            <td>{{ item.poNumber }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!--- DEPRECATED DATATABLE ----

    <p-dataTabl #dt
                 selectionMode="single"
                 [value]="page.items"
                 [lazy]="true"
                 [rows]="10"
                 [responsive]="true"
                 [paginator]="true"
                 rowHover="true"
                 resizableColumns="true"
                 [totalRecords]="page.total"
                 (onLazyLoad)="onGridLazyLoad($event)"
                 [loading]="isLoading"
                 [rowsPerPageOptions]="[5,10,20]"
                 [pageLinks]="3"
                 (onSort)="changeSort($event)"
                 [scrollable]="true">

        <p-column field="orderNumber" header="Order Number" [sortable]="true" [style]="{'width':'130px'}"></p-column>
        <p-column field="orderCreationDate" header="Order Creation Date" [sortable]="true" [style]="{'width':'200px'}"></p-column>
        <p-column field="vehicleRegistration" header="Vehicle Registration" [sortable]="true" [style]="{'width':'150px'}"></p-column>
        <p-column field="vehicleDescription" header="Vehicle Description" [sortable]="false" [style]="{'width':'150px'}"></p-column>
        <p-column field="vehicleWeight" header="Vehicle Weight" [sortable]="false" [style]="{'width':'150px'}"></p-column>
        <p-column field="collectionAddress" header="Collection Address" [sortable]="false" [style]="{'width':'150px'}"></p-column>
        <p-column field="collectionPostcode" header="Collection Postcode" [sortable]="false" [style]="{'width':'150px'}"></p-column>
        <p-column field="deliveryAddress" header="Delivery Address" [sortable]="false" [style]="{'width':'150px'}"></p-column>
        <p-column field="deliveryPostcode" header="Delivery Postcode" [sortable]="false" [style]="{'width':'150px'}"></p-column>
        <p-column field="earliestPickupDate" header="Earliest Pickup" [sortable]="true" [style]="{'width':'140px'}">
            <ng-template let-col let-order="rowData" pTemplate="body">
                <span>{{ order[col.field] | datex:'ddd DD MMM \'YY HH:mm' }}</span>
            </ng-template>
        </p-column>
        <p-column field="latestPickupDate" header="Latest Pickup" [sortable]="true" [style]="{'width':'140px'}">
                <ng-template let-col let-order="rowData" pTemplate="body">
                    <span>{{ order[col.field] | datex:'ddd DD MMM \'YY HH:mm' }}</span>
                </ng-template>
        </p-column>
        <p-column field="movementCompletedDate" header="Movement Completed Date" [sortable]="tru" [style]="{'width':'200px'}">
            <ng-template let-col let-order="rowData" pTemplate="body">
                <span>{{ order[col.field] | datex:'ddd DD MMM \'YY HH:mm' }}</span>
            </ng-template>
        </p-column>
        <p-column field="movementStatus" header="Movement Status" [sortable]="tru" [style]="{'width':'130px'}"></p-column>
        <p-column field="odometerStart" header="Odometer Start" [sortable]="false" [style]="{'width':'130px'}"></p-column>
        <p-column field="odometerEnd" header="Odometer End" [sortable]="fals" [style]="{'width':'130px'}"></p-column>
        <p-column field="googleMiles" header="Google Miles" [sortable]="tru" [style]="{'width':'130px'}"></p-column>
        <p-column field="movementType" header="Movement Type" [sortable]="tru" [style]="{'width':'130px'}"></p-column>
        <p-column field="movementCharge" header="Movement Charge" [sortable]="false" [style]="{'width':'140px'}">
            <ng-template let-order="rowData" pTemplate="body">
                <span>
                    {{ order.movementCharge | currency:'GBP':'symbol':'1.2-2' }}
                </span>
            </ng-template>
        </p-column>
        <p-column field="transactionFee" header="Transaction Fee" [sortable]="false" [style]="{'width':'140px'}">
            <ng-template let-order="rowData" pTemplate="body">
                <span>
                    {{ order.transactionFee | currency:'GBP':'symbol':'1.2-2' }}
                </span>
            </ng-template>
        </p-column>
        <p-column field="collectionAddress" header="Collection Address" [sortable]="false" [style]="{'width':'150px'}"></p-column>
        <p-column field="collectionPostcode" header="Collection Postcode" [sortable]="false" [style]="{'width':'150px'}"></p-column>
        <p-column field="deliveryAddress" header="Delivery Address" [sortable]="false" [style]="{'width':'150px'}"></p-column>
        <p-column field="deliveryPostcode" header="Delivery Postcode" [sortable]="false" [style]="{'width':'150px'}"></p-column>
        <p-column field="bookedByUser" header="Booked By User" [sortable]="tru" [style]="{'width':'130px'}"></p-column>
        <p-column field="taskArrivedStep" header="Task Arrived Step" [sortable]="false" [style]="{'width':'160px'}">
            <ng-template let-col let-order="rowData" pTemplate="body">
                <span>{{ order[col.field] | datex:'ddd DD MMM \'YY HH:mm' }}</span>
            </ng-template>
        </p-column>
        <p-column field="taskStartMovement" header="Task Start Movement" [sortable]="false" [style]="{'width':'160px'}">
            <ng-template let-col let-order="rowData" pTemplate="body">
                <span>{{ order[col.field] | datex:'ddd DD MMM \'YY HH:mm' }}</span>
            </ng-template>
        </p-column>
        <p-column field="taskTravelTime" header="Task Travel Time" [sortable]="tru" [style]="{'width':'130px'}"></p-column>
        <p-column field="totalAdditionalCharge" header="Total Additional Charge" [sortable]="false" [style]="{'width':'170px'}">
            <ng-template let-order="rowData" pTemplate="body">
                <span>
                    {{ order.totalAdditionalCharge | currency:'GBP':'symbol':'1.2-2' }}
                </span>
            </ng-template>
        </p-column>
        <p-column field="totalCharge" header="Total Charge" [sortable]="false" [style]="{'width':'140px'}">
            <ng-template let-order="rowData" pTemplate="body">
                <span>
                    {{ order.totalCharge | currency:'GBP':'symbol':'1.2-2' }}
                </span>
            </ng-template>
        </p-column>
    </p-dataTable>

    --->
  </div>
  <div class="ui-g-12" style="height: 40px; margin-top: 20px">
    <button
      type="button"
      pButton
      icon="fa ui-icon-file-download"
      label="Download"
      class="ui-button btn-to-right"
      (click)="downloadReport('orders_report_beta.csv')"
      [disabled]="page.total == 0"
    ></button>
  </div>
</div>
<ng-template #loading>Loading...</ng-template>
<p-dialog
  [header]="progressBarTitle"
  modal="true"
  [(visible)]="isLoading"
  appendTo="body"
  (onHide)="cancel()"
  [closable]="false"
>
  <p-progressBar mode="indeterminate"></p-progressBar>
  <div class="mt-4 ui-g-12">
    <button
      type="button"
      pButton
      label="Cancel"
      class="ui-button ui-button-secondary ui-g-12"
      (click)="cancel()"
    ></button>
  </div>
</p-dialog>
